<div *ngIf="successMessage" class="alert alert-success" role="alert">
    <mat-icon>thumb_up</mat-icon> &nbsp;
    <label style="vertical-align: text-bottom; margin-bottom: 0rem;">
        {{successMessage}}
    </label>
</div>
<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <label style="vertical-align: text-bottom; margin-bottom: 0rem;">
        {{errorMessage}}
    </label>
</div>
<div class="row_1">
    <div class="top_grid_agg">
        <div class="content">
            <div style="width: 30%; justify-content: left; display: flex;">
                <label class="catlabel">Template</label>
                <span class="content1">
                    <select class="drpdwn_template" [(ngModel)]="templateChosen" (change)="display()">
                        <option value="" selected>Select</option>
                        <option *ngFor="let template of templates" [value]="template.templateID">
                            {{template.description}}
                        </option>
                    </select>
                </span>
            </div>
            <div style="width: 70%; justify-content: right; display: flex;">
                <button class="refresh_button" (click)="refreshData()">REFRESH</button>
                <img src="../../../assets/images/Line 8225.svg" class="line" *ngIf="enableGrid">
                <button class="add_button" (click)="addTemplate()" title="Add Template">ADD TEMPLATE</button>
                <button class="delete_button" (click)="deleteTemplate()" *ngIf="enableGrid" title="Delete Template">DELETE TEMPLATE</button>
                <button class="export_button" (click)="uploadTemplate()" *ngIf="enableGrid" title="Upload Template">UPLOAD TEMPLATE</button>
                <button mat-raised-button class="download_template" *ngIf="enableGrid" (click)="downloadTemplate()">DOWNLOAD</button>
                <img src="../../../assets/images/Line 8225.svg" class="line" *ngIf="enableGrid">
                <button mat-raised-button class="add_task" (click)="addTask()" *ngIf="enableGrid">ADD TASK</button>
            </div>
        </div>
        <div class="grid-agg" *ngIf="enableGrid">
            <ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px',
            'width':'100%' }" id="templates-Grid" class="ag-theme-balham" [pagination]="setPagination"
                [columnDefs]="columnDefs" [rowData]="rowData" [icons]="icons" [defaultColDef]="defaultColDef"
                [paginationPageSize]="paginationPageSize" [suppressCellSelection]="true" [theme]="'legacy'"
                [rowHeight]="40" (gridReady)="onGridReady($event)" (window:resize)="sizeToFit()" [context]="context"
                [icons]="icons" [enableCellTextSelection]="true" [ensureDomOrder]="true"
                (filterChanged)="onFilterChanged($event)">
            </ag-grid-angular>
            <div class="custom-pagination" *ngIf="totalRecords > 0">
				<div class="left">
					<span class="records-per-page">
						<span>Records/Page : </span>
						<select [(ngModel)]="rpPage" (change)="rppChanged($event)">
							<option *ngFor="let size of pgDropDown" [value]="size.value">{{ size.value }}</option>
						</select>
					</span>
				</div>
				<div class="right">
					<span class="viewing-records">
						<span class="w-600">{{sRecord}}</span> to <span class="w-600">{{eRecord}}</span> of <span
							class="w-600">{{totalRecords}}</span>
						<button (click)="goToFirstPage()" [disabled]="getCurrentPage() === true"><i
								class="fa-solid fa-backward-fast"
								[ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<button (click)="goToPreviousPage()" [disabled]="getCurrentPage() === true"><i
								class="fa-solid fa-backward-step"
								[ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<span>Page <span class="w-600">{{cPage}}</span> of <span class="w-600">{{tPage}}</span></span>
						<button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-step"
								[ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-fast"
								[ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
					</span>
				</div>
			</div>
        </div>
    </div>
</div>